import React from 'react';
import { Switch, Route, Redirect, Router } from 'react-router-dom';
import { Layout } from 'antd/lib';
import RutaAutenticada from './auth/RutaAutenticada';

import history from '../routes/history';

import 'antd/dist/antd.css';
import 'antd/lib/layout/style';
import 'antd/lib/icon/style';
import 'antd/lib/breadcrumb/style';
import 'antd/lib/menu/style';
import '../assets/main.css';

// import Editor from './editor/EditorMain';
import Navbar from './common/Navbar';
const { Content, Footer } = Layout;

import EnConstruccion from './common/EnConstruccion';
import Tramites from './tramites/Container';
import Admin from './administracion/index';
import AdmGeneral from './admGeneral/index';
import ViolenciaGenero from './violenciaGenero/index';
import Documento from './documento/index.js';
import RRHH from './rrhh/index';
import Estadistica from './estadistica/index';
import Contravenciones from './contravenciones/index';
import ErrorBoundary from './common/ErrorBoundary';
import Documentos from './common/documentos';
import FormVerificacionAutorizacionContainer from './public/verificacionMenor/ViajeMenoresPublicContainer.js';
import FormVerificacionAutorizacionTrabajoMenor from './public/verificacionTrabajoMenor/TrabajoMenoresPublicContainer.js';

class App extends React.PureComponent {
  render() {
    const { authenticator } = this.props;

    return (
      <ErrorBoundary>
        <Router history={history}>
          <Layout>
            <Layout style={{ background: '#fff' }}>
              <Navbar authenticator={authenticator} />
              <div className="wrapper d-flex flex-column">
                <main className="flex-fill">
                  <Content style={{ padding: '64px 50px' }}>
                    <div
                      style={{ background: '#fff', padding: 5, minHeight: 280 }}
                    >
                      <Switch>
                        <RutaAutenticada
                          exact
                          path="/"
                          component={EnConstruccion}
                          {...this.props}
                        />

                        <RutaAutenticada
                          path="/tramites"
                          component={Tramites}
                          {...this.props}
                        />

                        <RutaAutenticada
                          path="/admin"
                          component={Admin}
                          {...this.props}
                        />

                        <RutaAutenticada
                          path="/administracionGeneral"
                          component={AdmGeneral}
                          {...this.props}
                        />

                        <RutaAutenticada
                          path="/violenciaGenero"
                          component={ViolenciaGenero}
                          {...this.props}
                        />

                        <RutaAutenticada
                          path="/documento"
                          component={Documento}
                          {...this.props}
                        />

                        <RutaAutenticada
                          path="/rrhh"
                          component={RRHH}
                          {...this.props}
                        />

                        <RutaAutenticada
                          path="/estadistica"
                          component={Estadistica}
                          {...this.props}
                        />

                        <RutaAutenticada
                          path="/contravenciones"
                          component={Contravenciones}
                          {...this.props}
                        />

                        <RutaAutenticada
                          path="/documentos"
                          component={Documentos}
                          {...this.props}
                        />

                        <Route
                          exact
                          path="/sijup"
                          render={() => <Redirect to="/" />}
                        />

                        <Route
                          exact
                          path="/viajeMenor"
                          render={() => <FormVerificacionAutorizacionContainer />}
                        />

                        <Route
                          path="/viajeMenor/:codigo"
                          render={(props) => <FormVerificacionAutorizacionContainer {...props} />}
                        />
                        
                        <Route
                          exact
                          path="/trabajoMenor"
                          render={() => <FormVerificacionAutorizacionTrabajoMenor />}
                        />

                        <Route
                          path="/trabajoMenor/:codigo"
                          render={(props) => <FormVerificacionAutorizacionTrabajoMenor {...props} />}
                        />
                      </Switch>
                    </div>
                  </Content>
                </main>
                <Footer className="footerGeneral" id="footer-pj">
                  Direccion General de Informatica ©2025
                </Footer>
              </div>
            </Layout>
          </Layout>
        </Router>
      </ErrorBoundary>
    );
  }
}

App.propTypes = {};

export default App;
